import { genericService } from "./genericService";

const section = "TypePayment";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return genericService.filter(section, "types", name, from, limit, active);
}
function getAll() {
  return genericService.get("TypePayment/ListAllTypePayment");
}
function remove(id) {
  return genericService.remove(section, id);
}

function create(item) {
  const param = {
    type: item.type,
  };
  return genericService.create(section, param);
}

function update(item) {
  const param = {
    id: item.id,
    type: item.type,
    isActive: item.isActive,
  };
  return genericService.update(section, param);
}

export const typePaymentService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
